module.exports = __webpack_public_path__ + "img/logo-italiansped-footer_140x50.b5095f34.png";